export default [
    { name: 'blog', visible: false },
    { name: 'music', text: 'Music' }
];
